import { css } from "@emotion/react";
import { useTheme } from "../theme";

export interface MediaStyleProps {
  /**
   * CSSではなく、widthプロパティを優先して利用してください。
   * @default "100%"
   */
  width?: string | number;
  /**
   * CSSではなく、heightプロパティを優先して利用してください。
   */
  height?: string | number;
  /**
   * 画像のアスペクト比を指定します。
   */
  aspectRatio?: React.CSSProperties["aspectRatio"] | number;
  style?: React.CSSProperties;
  className?: string;
}

interface MediaFallbackProps extends MediaStyleProps {
  children?: React.ReactNode;
}

export const MediaFallback = (props: MediaFallbackProps) => {
  const { width, height, aspectRatio, children, ...rest } = props;
  const theme = useTheme();
  return (
    <div
      css={[
        css`
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          container-type: inline-size;
        `,
        // @see https://github.com/emotion-js/emotion/issues/3011
        css`
          aspect-ratio: ${aspectRatio};
        `,
        {
          backgroundColor: theme.palette.gray[500],
          width,
          height,
        },
      ]}
      {...rest}
    >
      <div
        css={css`
          font-size: 16px;

          @container (min-width: 240px) {
            font-size: 24px;
          }
        `}
      >
        {children}
      </div>
    </div>
  );
};
